import { SVGProps } from 'react'

export const RemoveCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <rect width="24" height="24" fill="#fff" rx="12"></rect>
    <path fill="#FF5C38" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"></path>
  </svg>
)
